import React from 'react';
import { BothModes } from '../../types/fare';
import { formatPrice } from '../../services/fareService';
import { ArrowRight } from 'lucide-react';

interface ModeComparisonCardProps {
  modes: BothModes;
  premium: number;
}

export default function ModeComparisonCard({ modes, premium }: ModeComparisonCardProps) {
  return (
    <div className="bg-purple-50 border-2 border-purple-200 rounded-xl p-6 shadow-sm">
      <div className="text-center mb-4">
        <h3 className="text-lg font-semibold text-purple-900">Both Options Available</h3>
        <p className="text-sm text-purple-700">Choose based on your budget and comfort</p>
      </div>

      <div className="flex items-center justify-between gap-4">
        {/* Tuk-tuk */}
        <div className="flex-1 bg-white rounded-lg p-4 text-center">
          <div className="text-3xl mb-2">🛺</div>
          <div className="font-semibold text-gray-900 mb-1">Tuk-Tuk</div>
          <div className="text-sm text-gray-600 mb-2">Budget-friendly</div>
          <div className="text-lg font-bold text-purple-700">
            Rs. {formatPrice(modes.tuk.min)} - {formatPrice(modes.tuk.max)}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            Avg: Rs. {formatPrice(modes.tuk.base)}
          </div>
        </div>

        {/* Arrow with premium */}
        <div className="flex flex-col items-center">
          <ArrowRight className="text-purple-500 mb-1" size={24} />
          <div className="text-xs font-semibold text-purple-700 whitespace-nowrap">
            +Rs. {formatPrice(premium)}
          </div>
        </div>

        {/* Taxi */}
        <div className="flex-1 bg-white rounded-lg p-4 text-center">
          <div className="text-3xl mb-2">🚖</div>
          <div className="font-semibold text-gray-900 mb-1">Taxi</div>
          <div className="text-sm text-gray-600 mb-2">More comfort</div>
          <div className="text-lg font-bold text-purple-700">
            Rs. {formatPrice(modes.taxi.min)} - {formatPrice(modes.taxi.max)}
          </div>
          <div className="text-xs text-gray-500 mt-1">
            Avg: Rs. {formatPrice(modes.taxi.base)}
          </div>
        </div>
      </div>

      <div className="mt-4 text-center text-sm text-purple-800 bg-purple-100 rounded-lg p-3">
        💡 Taxi costs <span className="font-semibold">Rs. {formatPrice(premium)}</span> more on average than Tuk-Tuk
      </div>
    </div>
  );
}

